import { Search, FileSignature, CalendarCheck, Film } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    title: "Browse vetted creators",
    body: "Hand-picked UGC creators and micro-influencers in hospitality, food, beauty, and lifestyle — reviewed by our editors.",
  },
  {
    icon: FileSignature,
    title: "Choose a contract",
    body: "Pick the format that fits — from a single visit to a full visit + shoot + digital sponsorship campaign.",
  },
  {
    icon: CalendarCheck,
    title: "Schedule the visit",
    body: "Coordinate the on-site shoot directly. We handle briefs, deliverables, and timelines.",
  },
  {
    icon: Film,
    title: "Receive the content",
    body: "Get raw clips, edited verticals, and ready-to-post deliverables — owned by your brand.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">
              How it works
            </p>
            <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] mt-4 text-[#0D3A35]">
              Four steps,
              <br />
              <span className="text-[#276152]">zero</span> guesswork.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-lg leading-relaxed text-[#0D3A35]/75">
              We&apos;ve removed the messy DMs, missed expectations, and confused
              briefs. From discovery to deliverables, your team gets a calm,
              guided workflow with everything in writing.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#B1B7AB]/40 border border-[#B1B7AB]/40 rounded-2xl overflow-hidden">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`step-${i + 1}`}
                className="bg-[#FFFFFF] p-8 lg:p-10 flex flex-col gap-6 min-h-[280px]"
              >
                <div className="flex items-center justify-between">
                  <span className="font-serif text-3xl text-[#276152]">
                    0{i + 1}
                  </span>
                  <Icon className="w-5 h-5 text-[#0D3A35]" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-serif text-2xl text-[#0D3A35] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#0D3A35]/70">
                    {s.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
